import { Component, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';

import { bitfToTranslate } from '@common/libs/bitforce/utils/bitf-translate.utils';
import { EApiCallStateNames, EApiRequestPartKeys, ERoleActions } from '@enums';

import { IFsItemAction, IFsItemActionEvent } from '@interfaces';
import { EFsAction } from './fs-actions.enum';
import { FsItem, FsStore } from '@models';
import { ApiCallStateService, UiRoleManagerService, StoreService } from '@services';

@Component({
  selector: 'prada-fs-actions',
  templateUrl: './fs-actions.component.html',
  styleUrls: ['./fs-actions.component.scss'],
})
export class FsActionsComponent implements OnChanges {
  @Input() fsItem: FsItem;
  @Input() fsStore: FsStore;
  @Output() fsItemActionClick = new EventEmitter<IFsItemActionEvent>();

  apiCallStateName = EApiCallStateNames.DOCUMENT_ARCHIVE_LIST;

  fsItemActionsList: IFsItemAction[] = [];

  constructor(
    private apiCallStateService: ApiCallStateService,
    private uiRoleManagerService: UiRoleManagerService,
    private storeService: StoreService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.apiCallStateName = this.fsStore.configuration.apiCallStateName;
    if (changes.fsItem && changes.fsItem.currentValue) {
      this.createMenu();
    }
  }

  private createMenu() {
    // NOTE: download is not available for folders yet
    this.fsItemActionsList = [];

    if (this.uiRoleManagerService.canI(ERoleActions.RENAME, { fsStore: this.fsStore })) {
      this.fsItemActionsList.push({
        action: EFsAction.RENAME,
        label: bitfToTranslate('COMMON.LABEL.RENAME'),
      });
    }

    if (this.uiRoleManagerService.canI(ERoleActions.DELETE, { fsStore: this.fsStore })) {
      this.fsItemActionsList.push({
        action: EFsAction.DELETE,
        label: bitfToTranslate('COMMON.LABEL.DELETE'),
      });
    }

    if (!this.fsItem.isFolder) {
      if (this.uiRoleManagerService.canI(ERoleActions.DOWNLOAD, { fsStore: this.fsStore })) {
        this.fsItemActionsList.splice(1, 0, {
          action: EFsAction.DOWNLOAD,
          label: bitfToTranslate('COMMON.LABEL.DOWNLOAD'),
        });
      }

      const searchRequestPart = this.apiCallStateService.getRequestPart(
        this.apiCallStateName,
        EApiRequestPartKeys.SEARCH
      );

      const isAdvancedSearch = searchRequestPart.formValue
        ? searchRequestPart.formValue.fullText && searchRequestPart.formValue.fullText !== ''
        : false;

      if (
        !isAdvancedSearch &&
        this.uiRoleManagerService.canI(ERoleActions.SHOW_TAG, { fsStore: this.fsStore })
      ) {
        this.fsItemActionsList.splice(2, 0, {
          action: EFsAction.TAGS,
          label: bitfToTranslate('COMMON.LABEL.TAGS'),
        });
      }
    }
  }

  onMenuClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onFsItemActionClick(actionSelected: IFsItemAction) {
    this.fsItemActionClick.emit({ action: actionSelected.action, fsItem: this.fsItem });
  }
}
